import React from "react";
import { GoogleLogo } from "@phosphor-icons/react";

// Emergent Google OAuth login trigger.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleLoginButton({ label = "Continue with Google", testId = "google-login-btn" }) {
  const onClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className="w-full border border-[--ink] bg-white px-4 py-3 text-sm font-semibold inline-flex items-center justify-center gap-3 hover:bg-[--ink] hover:text-white transition-colors"
    >
      <GoogleLogo weight="bold" size={18} />
      {label}
    </button>
  );
}
